<template>
  <div>
    <v-col v-if="searchBox" cols="12" id="searchBoxDiv">
      <SearchBox
        id="searchBox"
        @search="search = $event"
      />
    </v-col>
    <ListOneLItemsSelect
      :items="computedCondicoesPagamento"
      itemTitle="condicao_pagamento"
      :fullscreen="true"
      :searchBox="searchBox"
      @clicked="$emit('condicaoPagamentoSelected', $event)"
    />
    <div class="my-3" id="listCondicoesPagamentoPagination">
      <v-pagination
        v-model="page"
        :length="totalPages"
        circle
      ></v-pagination>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import SearchBox from '@/components/shared/SearchBox';
import ListOneLItemsSelect from '@/components/shared/list/ListOneLItemsSelect';
import { convertStringToCompare } from '@/helpers';

export default {
  name: 'ListCondicoesPagamentoSelect',
  props: {
    searchBox: {
      type: Boolean,
      default: false
    }
  },
  data: () => ({
    page: 1,
    order: 'id_condicao_pagamento',
    search: '',
  }),
  components: {
    SearchBox,
    ListOneLItemsSelect
  },
  computed: {
    ...mapGetters(['condicoesPagamento']),
    computedCondicoesPagamento() {
      const start = (this.page - 1) * 10;
      const end = start + 10;
      let searchTerm = this.search || '';
      searchTerm = convertStringToCompare(searchTerm);
      return this.condicoesPagamento
        .filter(condicaoPagamento =>
          Object.keys(condicaoPagamento)
            .some(key => convertStringToCompare(condicaoPagamento[key]).includes(searchTerm || ''))
        )
        .slice(start, end)
        .sort((a, b) => a[this.order] > b[this.order] ? 1 : -1);
    },
    totalPages() {
      const total = this.condicoesPagamento.length / 10;
      return total !== Infinity ? Math.ceil(total) : 0;
    }
  },
}
</script>

<style>

</style>